var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.activeStat),callback:function ($$v) {_vm.activeStat=$$v},expression:"activeStat"}},[_c('v-card',[_c('v-card-text',[(_vm.user)?_c('AddUserFrom',{attrs:{"item":_vm.user,"rank":_vm.rank},on:{"userSaved":_vm.close}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }